import { useQuery } from "@tanstack/react-query";
import apiRoutes from "../apiRoutes";
import api from "../utils";

export const useHistory = (type?: string) => {

    const fetchTrans = async () => {
        const res = await api.post(apiRoutes.history, {
            type
        });
        return res.data;
    };

    const { data, ...rest } = useQuery<TransactionHistory>({
        queryKey: ["fetch_trans", type],
        queryFn: fetchTrans,
    });

    return {
        data,
        history: data?.info,
        ...rest
    }
}